import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UbiModule } from '../theme/ubi.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MomentModule } from 'angular2-moment';
import { NgUploaderModule } from 'ngx-uploader';
import { ToastrModule } from 'ngx-toastr';
import { TagInputModule } from 'ngx-chips';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';

import { UbiCoreModule, ApiService, MetadataService } from '../ubi-core/ubi-core.module';

import { MovementsMobileComponent } from './mobile/movements/movements.component';
import { MovementMobileComponent } from './mobile/movements/movement.component';
import { MovementsComponent } from './backoffice/movements/movements.component';
import { MovementComponent } from './backoffice/movements/movement.component';
import { AnnouncementComponent } from './backoffice/announcements/announcement.component';
import { AnnouncementsComponent } from './backoffice/announcements/announcements.component';
import { AnnouncementItemsComponent } from './backoffice/announcementItems/announcementItems.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MapaComponent } from './mapas/mapa.component';
import { TemplateComponent } from './config/templates/template.component';
import { CustomerComponent } from './backoffice/customers/customer.component';
import { CustomerReportsComponent } from './customerReports/customer-reports.component';
import { CustomerReportsDetailComponent } from './customerReports/customer-reports-detail.component';
import { CustomerReportsLoadTruckComponent } from './customerReports/customer-reports-loadtruck.component';

import { ProfileComponent } from '../auth/profile.component';
import { UsersComponent } from './config/users/users.component';
import { UserComponent } from './config/users/user.component';

import { AnnouncementService } from './backoffice/announcements/announcement.service';
import { MovementService } from './backoffice/movements/movement.service';
import { CustomerReportsService } from './customerReports/customer-reports.service';

import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';
import {
  DynamicEntityModule, DynamicDetailComponent,
  DynamicGridComponent, DynamicListDetailComponent
} from '../dynamic-entity/dynamic-entity.module';

import { BaseRoutingModule } from './base-routing.module';

@NgModule({
  imports: [
    CommonModule,
    BaseRoutingModule,
    UbiModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    NgxDatatableModule,
    MomentModule,
    NgUploaderModule,
    ToastrModule.forRoot(),
    NgbModule,
    DynamicFormModule,
    DynamicEntityModule,
    TagInputModule,
    LoadingModule.forRoot({
      fullScreenBackdrop: true,
      animationType: ANIMATION_TYPES.wanderingCubes,
      primaryColour: '#2086bf',
      secondaryColour: '#007ca3',
      tertiaryColour: '#114968'
    })
  ],
  declarations: [
    MovementsMobileComponent,
    MovementMobileComponent,
    MovementsComponent,
    MovementComponent,
    DashboardComponent,
    ProfileComponent,
    UsersComponent,
    UserComponent,
    MapaComponent,
    AnnouncementsComponent,
    AnnouncementComponent,
    AnnouncementItemsComponent,
    TemplateComponent,
    CustomerComponent,
    CustomerReportsComponent,
    CustomerReportsDetailComponent,
    CustomerReportsLoadTruckComponent
  ],
  providers: [
    ApiService,
    MetadataService,
    AnnouncementService,
    MovementService,
    CustomerReportsService
  ],
})
export class AvemovBaseModule { }



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/base.module.ts